import CartUtil from 'common/util/CartUtil';

class ToCart {
	static select = $context => $context.select('.to-cart');

	constructor($toCart) {
		this.$toCart = $toCart;

		this.bindEvents();
		this.fixAddCartBtnsBlock();
	}

	bindEvents() {
		const self = this;

		const $btnWrapper = self.$toCart.find('.to-cart__btn-wrap');

		self.$toCart.on('click', '.to-cart__buy1click', function(){
			self.$toCart.find('.buy1click-open-button').not("[data-dolyami]").trigger('click');
		});

		self.$toCart.on('click', '.product-cart__dolyame-buy-btn', function(){
			self.$toCart.find('.buy1click-open-button[data-dolyami="1"]').trigger('click');
		});

		self.$toCart.find('.to-cart__btn-bestprice').on('click', function(){
			const bestpriceBtn = self.$toCart.find('.i-bestprice__button');
			ModalUtil.openAjax(bestpriceBtn.data('url'), undefined, Update($('.bestprice')));
		});

		self.$toCart.find('.to-cart__btn-analog').on('click', function(e){
			e.preventDefault();

			var target = $(this).attr('href');
			ScrollUtil.scrollTo($(target).offset().top - 60);
			if( typeof yaCounter26476791 != 'undefined' ) {
				yaCounter26476791.reachGoal('ANALOG_PROD');
			}
		});

		$(document).ready(function () {
			var analogBtn = self.$toCart.find('.to-cart__btn-analog');

			if (analogBtn.length && Cookies.get('to_upselling') !== undefined) {
				analogBtn.trigger('click');
				Cookies.remove('to_upselling');
			}
		});

		self.$toCart.find('.to-cart__btn-haggle').on('click', function(){
			ModalUtil.openAjax('/haggle/?product_id=' + $(this).data('pid'), undefined, );
		});

		self.$toCart.on('change', '.quantity', function(e) {
			e.stopPropagation();

			const cartItemId = $btnWrapper.find('.to-cart__buy').data('cart-item-id');

			if (cartItemId !== '') {
				const $quantityBlock = $(this);
				const $quantityInput = $quantityBlock.find('.quantity__input');
				const quantity = $quantityInput.val();

				if (quantity > 0) {
					CartUtil.updateItem(cartItemId, $quantityInput.val(), true).then(function (response) {
						$(document).trigger('cart_item_change_quantity', quantity);
					});
				} else {
					CartUtil.deleteItem(cartItemId).then(function (response) {
						$(document).trigger('cart_item_deleted');
					});
				}
			}
		});

		$(window).scroll(function() {
			self.fixAddCartBtnsBlock();
		});

		$(window).resize(function() {
			self.fixAddCartBtnsBlock();
		});

		$(document).on('before_add_to_cart', function (e, params) {
			const {product_id, sku_id} = params;
			const $addToCartBtn = self.$toCart.find('.to-cart__buy-btn');

			const isCurrentProduct = product_id === $addToCartBtn.data('product-id') && sku_id ===  $addToCartBtn.data('sku-id');

			if ($btnWrapper.data('add-block') !== undefined && isCurrentProduct) {
				const $currentBlockHtml = $btnWrapper.html();
				$btnWrapper.data('add-block', $currentBlockHtml);
			}
		});

		$(document).on('change_btn_added_to_cart', function (e, params) {
			const {product_id, sku_id, item_id} = params;
			const $addToCartBtn = self.$toCart.find('.to-cart__buy-btn');

			if ($btnWrapper.data('added-block') !== undefined) {
				$btnWrapper.html($btnWrapper.data('added-block'));
				$btnWrapper.find('.to-cart__buy').data('cart-item-id', item_id);
				Update($btnWrapper.find('.quantity'));
			}
		});

		$(document).on('cart_item_deleted', function(e) {
			if ($btnWrapper.data('add-block') !== undefined) {
				$btnWrapper.html($btnWrapper.data('add-block'));
			}
		});

		$(document).on('cart_item_change_quantity', function(e, quantity) {
			if (quantity !== undefined) {
				const $quantityBlock = self.$toCart.find('.quantity');
				const $addToCartBtn = self.$toCart.find('.to-cart__buy-btn');

				if ($quantityBlock.length > 0) {
					$quantityBlock.trigger('update:cart-item', {val: quantity});
				}
				if ($addToCartBtn.length > 0) {
					const $countBlock = $addToCartBtn.find('.btn__text i');

					$countBlock.text(quantity);
				}
			}
		});
	}

	fixAddCartBtnsBlock() {
		const $addCartBlock = this.$toCart.find('.to-cart__buy--main');

		if (ResponsiveUtil.isToTablet()) {
			$addCartBlock.addClass('to-cart__buy--fixed');
		} else {
			$addCartBlock.removeClass('to-cart__buy--fixed');
		}
	}

}

export default () => Component(ToCart.select, $toCart => new ToCart($toCart));
